import { useNavigate } from 'react-router-dom'

import './_terms.scss';

const Terms = () => {

  const navigate = useNavigate()

  return (
    <>
    <div className="pf-content pf-content--not-home">
      <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             Terms of Service Agreement
            </h2>
          <div className="pf-content__description">
            <p>
              This terms-of-service agreement is entered into between you and
              Innodev Solutions Inc., a Delaware corporation (“
              <strong>AllFans</strong>,” “we,” or “us”). The following
              agreement, together with any documents it references
              (collectively, “agreement”), governs your access to and use of 
              <a href="/"> www.allfans.com</a>, including any content,
              functionality, and services offered on or through 
              <a href="/"> www.allfans.com</a> (“Website”), whether as a guest or a
              registered User.
            </p>
          </div>
          <ol className="pf-main-list">
            <li>
              <h5>Definitions</h5>
              <p>In this agreement, the following definitions apply:</p>
              <p>
                <strong>“Content”</strong> means any material uploaded to the
                Website by any User (whether a Creator or a Fan), including any
                photos, videos, audio (for example, music and other sounds),
                livestream material, data, text (including comments and
                hashtags), metadata, images, interactive features, emojis, GIFs,
                memes, and any other material.
              </p>
              <p>
                <strong>“Creator”</strong> means a User who has set up their
                AllFans account as a Creator account to post Content on
                the Website to be viewed by other Users.
              </p>
              <p>
                <strong>“Fan”</strong> means a User who follows a Creator and
                can view the Creator’s Content.
              </p>
              <p>
                <strong>“Fan/Creator Transaction”</strong> means any transaction
                between a Fan and Creator on the Website by which access is
                granted to the Creator’s Content, including in any of the
                following ways: (1) a Subscription, (2) payments made by a Fan
                to view a Creator’s pay-per-view Content (pay-per-view media and
                pay-per-view live stream), and (3) use by the Fan of the fan
                interaction function on a Creator’s account.
              </p>
              <p>
                <strong>“Fan Payment”</strong> means any payments made by a Fan
                to a Creator (1) for a Fan/Creator Transaction, or (2) by way of
                a tip for a Creator.
              </p>
              <p>
                <strong>“Standard Agreement between Fan and Creator”</strong>{" "}
                means the terms that govern each Fan/Creator Transaction that
                are available at <a href="/fancreatorcontract" onClick={(e) => { e.preventDefault(); navigate('/fancreatorcontract') }}>www.allfans.com/fancreatorcontract</a>.
              </p>
              <p>
                <strong>“Subscription”</strong> means a Fan’s subscription to a
                Creator’s account (whether paid or unpaid, and whether for one
                month or as part of a bundle comprising a subscription for more
                than one month).
              </p>
              <p>
                <strong>“Tax”</strong> means all forms of tax and statutory,
                governmental, state, federal, provincial, local government, or
                municipal charges, duties, imposts, contributions, levies,
                withholdings, or liabilities wherever chargeable in any
                jurisdiction.
              </p>
              <p>
                <strong>“User”</strong> means any user on <strong>AllFans</strong>, whether a Creator or a Fan or
                both (also referred to as <strong>“you”</strong> or{" "}
                <strong>“your”</strong>).
              </p>
            </li>
            <li>
              <h5>Acceptance of Agreement</h5>
              <ol>
                <li>
                  <p>
                    This document contains very important information regarding
                    your rights and obligations, and conditions, limitations,
                    and exclusions that might apply to you. Please read it
                    carefully.
                  </p>
                </li>
                <li>
                  <div className="pf-alert">
                    <strong>
                      Section 28 of this agreement contains a mandatory
                      arbitration agreement. By using our Website and accepting
                      this Aagreement, you hereby (1) agree to binding
                      arbitration of these claims before a neutral arbitrator;
                      and (2) waive your rights to go to court, have a jury hear
                      your case, or participate as part of a class of plaintiffs
                      for any disputes with us.
                    </strong>
                  </div>
                </li>
                <li>
                  <p>
                    <strong>
                      By using the Website or by clicking to accept or agree to
                      the agreement when this option is made available to you,
                      you accept and agree to be bound and abide by this
                      agreement.
                    </strong>{" "}
                    If you do not want to agree to this agreement, you must not
                    access or use the Website.
                  </p>
                </li>
                <li>
                  <p>
                    This Website is offered and available to persons who are
                    18-years old or older, who have reached the age of majority
                    where they live, and who are not prohibited by law from
                    accessing or viewing sexually explicit content. By using
                    this Website, you state that the following facts are
                    accurate: (1)you are at least 18-years old; (2) if the laws
                    of your jurisdiction provide that you can only be legally
                    bound by a contract at an age that is higher than 18-years
                    old, then you are old enough to be legally bound by a
                    contract under the laws of that jurisdiction; (3) you will
                    provide all other information or verification as we require;
                    (4) you are permitted by the laws of your jurisdiction to
                    join the Website and to view any Materials available on it
                    and to use any functionality provided by it; and (5) you are
                    able and willing to make payment (where required) to view
                    Materials available on the Website that you wish to view. If
                    you do not meet all these requirements, you must not access
                    or use the Website.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h5>Changes to Agreement</h5>
              <p>
                We may revise and update this agreement from time to time. The
                Website will require you to review and agree to the amended
                agreement before you can continue to use the Website. All
                changes are effective immediately when posted and apply to all
                access to and use of the Website afterward. However, any changes
                to section 27 (Governing Law and Jurisdiction) or section 28
                (Arbitration) will not apply to any disputes for which the
                parties have actual notice on or before the date the change is
                posted on the Website.
              </p>
            </li>
            <li>
              <h5>Adult Material; Section 230(d) Notice</h5>
              <p>
                You acknowledge that you are aware that some of the Content on
                the Website contains adult material, including graphic visual
                depictions and descriptions of nudity and sexual activity, and
                you will take this into account when deciding where to access
                and view Content. We will not be responsible to you if you
                suffer any loss or damage as a result of your accessing or
                viewing Content containing adult material in a way that places
                you in breach of any contract you have with a nonparty (for
                example, your employment contract) or in breach of any law.
              </p>
              <p>
                Under <a href="https://www.law.cornell.edu/uscode/text/47/230">47 U.S.C. § 230(d)</a>, you are notified that
                parental control protections (including computer hardware,
                software, or filtering services) are commercially available that
                may help in limiting access to material that is harmful to
                minors. You may find information about providers of these
                protections on the Internet by searching “parental control
                protection” or similar terms. If minors have access to your
                computer, please restrain their access to sexually explicit
                material by using these products, which we provide for
                informational purposes only and do not endorse:{" "}
                <a href="https://www.cybersitter.com/">CYBERsitter™</a> | <a href="https://www.netnanny.com/">Net Nanny®</a> |{" "}
                <a href="https://www.cyberpatrol.com/">CyberPatrol</a> | <a href="https://www.cyberpatrol.com/">ASACP</a>.
              </p>
            </li>
            <li>
              <h5>Child Sexual Abuse Material (CSAM) Prohibited</h5>
              <p>
                We prohibit material involving minors on the Website. We only
                allow visual media of consenting adults for consenting adults on
                the Website. If you see any visual media, real or simulated,
                depicting minors engaged in sexual activity on the Website or
                that is otherwise exploitative of children, please promptly
                report this to us at abuse@allfans.com. Please include with your
                report all appropriate evidence, including the date and time of
                identification.{" "}
              </p>
              <p>
                We will promptly investigate all reports and take proper action,
                including, but not limited to, termination of the User’s
                account, blocking the User from opening a new account on the
                Website, and withholding any payments owed to the User. We
                cooperate with any law enforcement agency investigating alleged
                child exploitation or child sexual abuse material.
              </p>
            </li>
            <li>
              <h5>No Prostitution or Sex Trafficking</h5>
              <p>
                Users must not use the Website to engage in, participate in,
                assist, support, or facilitate any act of prostitution, sex
                trafficking of children, or sex trafficking by force, fraud, or
                coercion. This includes using the Website to: (1) exchange any
                personal contact information with any User or have any type of
                face-to-face meeting involving one or more Users; or (2) discuss
                with any User any type of transaction involving use of any other
                service or method of interfacing with that User, including using
                any other Internet-based service or product. Any violation of
                these prohibitions will result in termination of the User’s
                account, blocking the User from opening a new account on the
                Website, and withholding any payments owed to the User. If you
                see any evidence of prostitution, sex trafficking of children,
                or sex trafficking by force, fraud, or coercion on this Website,
                please promptly report it to us at abuse@allfans.com. Please
                include with your report all evidence, including the date and
                time of identification.
              </p>
              <p>
                <strong>
                  If you are a victim of any type of prostitution, sex
                  trafficking of children, or sex trafficking by force, fraud,
                  or coercion, please promptly contact local law enforcement and
                  provide them with all the relevant information. Additionally,
                  please notify AllFans by submitting a private report
                  and provide AllFans with the specific details.
                </strong>
              </p>
              <p>
                We will promptly investigate all reports and take proper action.
                AllFans will cooperate with any criminal investigation
                by any law enforcement agency.
              </p>
            </li>
            <li>
              <h5>Accessing the Website</h5>
              <p>
                We may withdraw or amend our Website and any service or material
                provided on it without notice. We will not be liable if, for any
                reason, any part of the Website is unavailable at any time or
                for any period. From time to time, we may restrict access to
                some parts of the Website, or the entire Website, to Users,
                including registered Users. You are responsible for making all
                arrangements necessary for you to access the Website and its
                Materials.{" "}
              </p>
              <p>
                Access to the Website might not be legal by certain persons or
                in certain jurisdictions or might require age verification. We
                are not making any statement that the Website or its Materials
                are accessible or appropriate in your jurisdiction. Please check
                with your individual jurisdiction for legality. Otherwise, you
                access the Website on your own initiative and are responsible
                for complying with local laws.
              </p>
            </li>
            <li>
              <h5>
                Your Account; Account Security; Account Deletion; Communication
                Preferences
              </h5>
              <ol>
                <li>
                  <p>
                    To access many of the Website’s features, you must create an
                    account. Registration is free and for a single User only. To
                    register, you must complete the registration process by
                    providing us with accurate information as prompted by the
                    registration form. You must provide a valid email address, a
                    username, and a password or authenticate using any
                    third-party service offered on the Website. Do not choose a
                    username that is offensive or that infringes anyone’s
                    service mark, trademark, or trade name. We may delete or
                    require you to change any username that violates this
                    section 8(a). Your password should be unique (meaning that
                    it is different from those you use for other websites) and
                    must comply with the Website’s technical requirements for
                    the composition of passwords. By creating an account, you
                    state that (1)all account registration and profile
                    information you provide is your own and is accurate; (2) if
                    you previously had an account on the Website, we did not
                    suspend or terminate that account for breach of this
                    agreement or any other agreement between you and 
                    <strong>AllFans</strong>; and (3)you are creating an
                    account for your personal use, and you will not sell, rent,
                    or transfer your account to anyone.
                  </p>
                </li>
                <li>
                  <p>
                    You are responsible for keeping your password and account
                    confidential. Further, you are responsible for all
                    activities that occur under your account. You must promptly
                    let us know about any unauthorized use of your account or
                    any other security breach. You must not sell, rent, lease,
                    share, or provide access to your account to anyone else,
                    including charging anyone for access to administrative
                    rights on your account. We may disable any username,
                    password, or other identifier, whether chosen by you or
                    provided by us, for any reason, including if, in our
                    opinion, you have violated any part of this agreement or any
                    other agreement between you and AllFans. We may
                    cancel unconfirmed accounts or accounts that have been
                    inactive for more than a year.
                  </p>
                </li>
                <li>
                  <p>
                    We will not be liable to you for any loss that you might
                    incur because of someone else using your password or
                    account, either with or without your knowledge. You could be
                    held liable for losses incurred by another person or us
                    because of someone else’s use of your password or account.
                  </p>
                </li>
                <li>
                  <p>You must not use anyone else’s account at any time.</p>
                </li>
                <li>
                  <p>
                    We care about the integrity and security of your personal
                    information. But we cannot guarantee that unauthorized
                    persons can never defeat the Website’s security measures or
                    use any personal information you provide to us for improper
                    purposes. You provide your personal information at your own
                    risk.
                  </p>
                </li>
                <li>
                  <p>
                    f you want to delete your <strong>AllFans </strong>
                    account then you may do so in the “User Account” section of
                    your <strong>AllFans</strong> account. Account
                    deletion is subject to the following rules:
                  </p>
                  <ol>
                    <li>
                      <p>
                        if you are a Fan, the deletion of your account will take
                        place within a reasonable time after your request;
                      </p>
                    </li>
                    <li>
                      <p>
                        if you are a Creator, then once you initiate the account
                        deletion process your account will remain open until the
                        last day of your Fans’ paid Subscription period, after
                        which you will receive your final payment and your
                        account will be deleted;
                      </p>
                    </li>
                    <li>
                      <p>
                        if you are both a Fan and a Creator then your account
                        will be deleted in two stages (Fan first and then
                        Creator); and
                      </p>
                    </li>
                    <li>
                      <p>
                        once your account has been deleted you will not be
                        charged any further amounts or have access to your
                        former <strong>AllFans</strong> account or its
                        Content, and any Subscriptions will be deleted and
                        cannot be later renewed. You will receive an email
                        confirmation on the successful deletion of your account.
                        Once your account has been deleted, we may deal with
                        your Content in any appropriate manner in accordance
                        with our <a href="/privacypolicy" onClick={(e) => { e.preventDefault(); navigate('/privacypolicy') }}>Privacy Policy</a> (including by
                        deleting it) and you will no longer be entitled to
                        access your Content. There is no technical facility on 
                         <strong> AllFans</strong> for you to be able to
                        access your Content after termination of your account.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    By registering for an account, you hereby consent to receive
                    electronic communications from us about your account.
                    Communications might involve sending emails to the email
                    address you provided during registration or posting
                    communications on the Website and will include notices about
                    your account (e.g., change in password, confirmation emails,
                    and other transactional information) and are part of your
                    relationship with us. You acknowledge that any notices,
                    agreements, disclosures, or other communications that we
                    send you electronically will satisfy any legal communication
                    requirements, including that those communications be in
                    writing. We recommend that you keep copies of electronic
                    communications by printing a paper copy or saving an
                    electronic copy.{" "}
                  </p>
                  <p>
                    You also hereby consent to receive other communications from
                    us, including newsletters about new features and content,
                    special offers, promotional announcements, and customer
                    surveys by email or other methods. You acknowledge that
                    communications you receive from us might contain sexually
                    explicit material unsuitable for minors. If you no longer
                    want to receive non-transactional communications from us,
                    please review our <a href="/privacypolicy" onClick={(e) => { e.preventDefault(); navigate('/privacypolicy') }}>Privacy Policy</a> on how to
                    opt out of marketing communications.
                  </p>
                </li>
              </ol>
              </li>
              <li>
              <h5>
                Intellectual Property Rights
              </h5>
              <ol>
                <li>
                  <p>AllFans owns and operates the Website. All content, 
                    features, functionality, and other materials found on the Website, 
                    including all visual interfaces, graphics, information, software 
                    (including source code and object code), text, displays, images, 
                    photos, videos, and audio, and the design, selection, and arrangement 
                    of them (collectively, “Materials”) are owned by AllFans, 
                    its licensors, or other providers of those Materials. United States 
                    copyright, trademark, patent, trade secret, and other intellectual 
                    property or proprietary rights laws protect all Materials found on the Website.</p>
                </li>
                <li>
                  <p>AllFans hereby grants you a single, limited, personal, 
                    nontransferable, nonsublicensable, nonexclusive license (i.e., a personal 
                    and limited right) to access and use the Website and the Materials for 
                    your personal, noncommercial use only. You must not reproduce, distribute, 
                    resell, modify, create derivative works of, publicly display, publicly 
                    perform, republish, download, store, or transmit any of the Materials on 
                    the Website, except as follows:</p>
                    <ol>
                      <li><p>your computer may temporarily store copies of the Materials 
                        in RAM incidental to your accessing and viewing those Materials;</p></li>
                      <li><p>you may store files that are automatically cached by 
                        your Web browser for display enhancement purposes;</p></li>
                      <li><p>you may print or download one copy of a reasonable number 
                        of pages of the Website for your own personal, noncommercial use 
                        and not for further reproduction, publication, or distribution;</p></li>
                      <li><p>you may view any Content to which you have properly 
                        gained access solely for your personal, noncommercial use and not 
                        for further reproduction, publication, or distribution;</p></li>
                      <li><p>if we offer desktop, mobile, or other applications 
                        for download, you may download a single copy to your computer 
                        or mobile device solely for your own personal, noncommercial 
                        use, subject to our end user license agreement for those 
                        applications; and</p></li>
                      <li><p>if we provide social media features with certain 
                        content, you may take those actions as are enabled by those features.</p></li>
                    </ol>
                </li>
                <li>
                <ol>
                  <p>You must not:</p>
                    <li><p>download any Materials unless the Website itself gives you that option;</p></li>
                    <li><p>modify copies of any Materials from the Website;</p></li>
                    <li><p>use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying text;</p></li>
                    <li><p>delete or alter any copyright, trademark, or other proprietary rights notices from copies of the Materials from the Website; and</p></li>
                    <li><p>access or use any part of the Website or the Materials available through it for any commercial purposes unless we agree otherwise in writing.</p></li>
                </ol>
                </li>
                <li>
                  <p>If you print, copy, modify, download, record, or otherwise use or provide 
                    any other person with access to any part of the Materials in breach of this agreement, 
                    your right to use the Website will terminate immediately, and you must, at our option, 
                    return or destroy any copies of the Materials you have made. No interest in the Website 
                    or any Materials on the Website is transferred to you, and AllFans reserves all 
                    rights not expressly granted. Any use of the Website not expressly permitted by this 
                    agreement is a breach of this agreement and might violate copyright, trademark, and other laws.</p>
                </li>
                <li>
                  <p>Innodev Solutions Inc.’s name and logo; the term AllFans; the 
                    Website’s logo; and all related names, domain names, logos, product and service names, 
                    designs, and slogans, as well as the Website’s look and feel, including all page headers, 
                    custom graphics, button icons, and scripts are trademarks or trade dress of AllFans, 
                    its affiliates, or licensors. You must not use those marks in whole or in part with any 
                    product or service that is not ours, in any manner that is likely to cause confusion among 
                    consumers, or in any way that disparages or discredits us, without first obtaining our 
                    written permission. Any use of these marks must be under any guidelines that we may provide 
                    you with from time to time. All other service marks, trademarks, trade names, logos, product 
                    and service names, designs, and slogans on this Website are the marks of their respective 
                    owners. Reference on the Website to any products, services, processes, or other 
                    information—by trade name, trademark, manufacturer, supplier, or otherwise—does not 
                    constitute or imply our endorsement, sponsorship, recommendation, or any other affiliation.</p>
                </li>
              </ol>
              </li>
              <li>
              <h5>
                Prohibited Uses
              </h5>
                <ol>
                  <li>
                    <p>You must use the Website only for lawful purposes and in accordance with this 
                      agreement and the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>. You must not use the Website:</p>
                      <ol>
                        <li><p>in any way that violates any federal, state, local, or foreign law or 
                          regulation (including any laws about exporting data or software to and from the 
                          US or other countries);</p></li>
                        <li><p>to exploit, harm, or try to exploit or harm minors in any way by 
                          exposing them to inappropriate content, asking for personal information, or otherwise;</p></li>
                        <li><p>to engage in, take part in, aid, support, promote, ask for, or ease any 
                          act of prostitution, sex trafficking of children, or sex trafficking by force, fraud, 
                          or coercion;</p></li>
                        <li><p>to harass or stalk any person;</p></li>
                        <li><p>to send, knowingly receive, upload, download, use, or re-use any 
                          Content that does not comply with the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>;</p></li>
                        <li><p>to transmit, or procure the sending of, any advertising or promotional 
                          material without our prior written consent, including any “junk mail,” “chain 
                          letter,” “spam,” or any other similar solicitation;</p></li>
                        <li><p>to impersonate or try to impersonate us, a AllFans employee, 
                          another User, or any other person or entity (including by using email addresses 
                          or usernames associated with any of the preceding); or</p></li>
                        <li><p>to engage in any other conduct that restricts or inhibits anyone’s use 
                          or enjoyment of the Website, or which, as we decide, may harm our Users or us or 
                          expose them or us to liability.</p></li>
                      </ol>
                  </li>
                  <li>
                    <p>Additionally, you must not:</p>
                    <ol>
                      <li>
                        <p>use the Website in any way that could disable, overburden, damage, or impair the Website 
                          or interfere with any other person’s use of the Website, including their ability to engage in 
                          real-time activities through the Website;</p>
                      </li>
                      <li>
                        <p>conduct, facilitate, authorize, or permit any text or data mining or web scraping 
                          regarding the Website or any services provided through, or concerning, the Website. This includes 
                          using (or permitting, authorizing, or attempting to use): (A) any “robot,” “bot,” “spider,” 
                          “scraper,” or other automated device, program, tool, algorithm, code, process, or methodology 
                          to access, obtain, copy, monitor, record, or republish any part of the Website or any data, 
                          content, information, or services accessed through the Website; or (B) any automated 
                          analytical technique aimed at analyzing text and data in digital form to generate information 
                          that includes but is not limited to patterns, trends, and correlations;</p>
                      </li>
                      <li>
                        <p>use any manual process to monitor or copy any of the Materials or any other unauthorized 
                          purpose without our prior written consent;</p>
                      </li>
                      <li>
                        <p>use any device, software, or routine that interferes with the proper working of the Website;</p>
                      </li>
                      <li>
                        <p>introduce any viruses, Trojan horses, worms, logic bombs, or other material that is 
                          malicious or technologically harmful;</p>
                      </li>
                      <li>
                        <p>attempt to gain unauthorized access to, interfere with, damage, or disrupt any part of the 
                          Website, the server on which the Website is stored, or any server, computer, or database 
                          connected to the Website;</p>
                      </li>
                      <li>
                        <p>attack the Website via a denial-of-service attack or a distributed denial-of-service attack; or</p>
                      </li>
                      <li>
                        <p>otherwise try to interfere with the Website’s proper working.</p>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Content</h5>
                <ol>
                  <li>
                    <p>The Website contains personal webpages or profiles, live streaming, 
                      private messaging, timelines, comment sections, and other interactive features 
                      (collectively, “Interactive Services”) that allow Users to post, submit, publish, 
                      display, or transmit to other Users (collectively, “post”) Content on or through 
                      the Website. All Content must comply with the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>. If you are a 
                      Creator, you must also comply with the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a>. We will consider 
                      nonconfidential and nonproprietary any Content you post to the Website.</p>
                  </li>
                  <li>
                    <p>Unless you are registered as a Creator, you must be a verified User 
                      before you can post or appear in Content on or through our Website. To 
                      become a verified User, you must first provide us with a government-issued 
                      picture identification card so that we can verify your identity and age. By 
                      providing us with a government-issued picture identification card, you hereby 
                      authorize us to provide your government-issued picture identification card to 
                      a nonparty vendor for validation purposes.</p>
                  </li>
                  <li>
                    <p>As between you and AllFans, you own all intellectual property 
                      rights in the Content you submit. By making Content available on the Website 
                      or otherwise posting on the Website, you hereby grant us a perpetual, 
                      irrevocable, nonexclusive, sublicensable, worldwide license covering your Content 
                      or what you post in all formats and channels now known or later developed anywhere 
                      in the world to use, copy, reproduce, store, translate, transmit, distribute, 
                      perform, prepare derivative works, publicly display, and display in connection 
                      with any name, username, voice, or likeness provided in connection with it.</p>
                  </li>
                  <li>
                    <p>You hereby waive any so-called “moral rights” that you might have in any Content.</p>
                  </li>
                  <li>
                    <p>You state that the following facts about any Content you post on or through the Website are accurate:</p>
                    <ol>
                      <li>
                        <p>you have the right to submit the Content to the Website and grant the licenses in this agreement;</p>
                      </li>
                      <li>
                        <p>all persons depicted in your Content were at least 18 and the age of majority in your jurisdiction at the time of production;</p>
                      </li>
                      <li>
                        <p>AllFans will not need to obtain licenses from any nonparty or pay royalties to 
                          any nonparty for the distribution of the Content;</p>
                      </li>
                      <li>
                        <p>you have obtained and will keep on record appropriate written releases or 
                          consents from all persons (including yourself) who appear in the Content, including, 
                          but not limited to, (A) consent to be depicted in the Content; (B) consent to allow 
                          for the public distribution of the Content and to upload the Content to the Website; 
                          and (C) if the Content will be made available for downloading by other Users, consent 
                          to have that Content downloaded;</p>
                      </li>
                      <li>
                        <p>you have verified the identity and age of all persons depicted in your Content 
                          to ensure that all persons depicted are adults and you can provide supporting 
                          documents to us on request;</p>
                      </li>
                      <li>
                        <p>the Content does not, and will not, infringe any nonparty’s rights, 
                          including intellectual property rights, rights of publicity, moral rights, 
                          and privacy rights; and</p>
                      </li>
                      <li>
                        <p>the Content complies with this agreement, the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, 
                          the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a> if you are a Creator, and all laws.</p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>You acknowledge that you are responsible for any Content you post, and you, not us, have 
                      full responsibility for that Content, including its legality, reliability, accuracy, and 
                      appropriateness. We are not liable to any person for the content or accuracy of any Content 
                      posted by you or any other User. We use reasonable security measures to try to protect Content 
                      against unauthorized copying and distribution. But we do not guarantee that any unauthorized 
                      copying, use, or distribution of Content will not occur. <strong>We provide any security measures “as is” 
                      and we are not making any warranties, guarantees, conditions, or assurances that those security 
                      measures will withstand attempts to evade security mechanisms or that there will be no cracks, 
                      disablements, or other circumvention of those security measures</strong>. We will not be liable to you for 
                      any unauthorized copying, use, or distribution of your Content by nonparties, and to the greatest 
                      extent allowed by law, you hereby release all claims you might have against us for any such 
                      unauthorized copying or use of the Content, under any equitable or legal theory.</p>
                  </li>
                </ol>
              </li>
              <li>
               <h5>Monitoring and Enforcement; Termination</h5>
                <ol>
                  <li>
                    <p>We may:</p>
                    <ol>
                      <li>
                        <p>remove or refuse to post any Content for any reason;</p>
                      </li>
                      <li>
                        <p>take any action concerning any Content that we consider necessary or appropriate, 
                          including if we believe that your Content is illegal or otherwise violates this agreement 
                          or the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, infringes any intellectual property right or other right of 
                          any person or entity, threatens the personal safety of our Users or the public, or could 
                          create liability for AllFans;</p>
                      </li>
                      <li>
                        <p>disclose your identity or other information about you if required by law or 
                          court order (including a subpoena) to anyone who claims that Content posted by you 
                          violates their rights, including their intellectual property rights or their right to 
                          privacy or publicity;</p>
                      </li>
                      <li>
                        <p>take appropriate legal action, including referral to law enforcement, for any 
                          illegal or unauthorized use of the Website, including posting illegal or unauthorized 
                          Content (AllFans will report any Content that could be considered child sexual 
                          abuse material (CSAM) to the National Center for Missing and Exploited Children’s 
                          CyberTipline and any other legal and regulatory bodies);</p>
                      </li>
                      <li>
                        <p>terminate your agreement with us and your access to the Website for any reason by 
                          giving you at least 30 days’ prior notice by email or electronic message to your 
                          AllFans account; or</p>
                      </li>
                      <li>
                        <p>suspend access to your User account or terminate your agreement with use 
                          and your access to the Website effective immediately and without prior notice: 
                          (A) if we think that you have or might have materially or repeatedly breached 
                          any part of this agreement (including in particular our <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>) 
                          or the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a> if you are a Creator, or if you try or threaten to 
                          breach any part of this agreement in a way that has or could have serious consequences 
                          for us or another User; (B) if you engage in any activity that is illegal or fraudulent 
                          or otherwise violate any law; or (C) if you take any action that in our opinion has 
                          caused or is reasonably likely to cause us to suffer a loss or that otherwise harms 
                          the reputation of AllFans.</p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>AllFans has a <a href="/complaintspolicy" onClick={(e) => { e.preventDefault(); navigate('/complaintspolicy') }}>Complaints Policy</a> that allows anyone to report to AllFans 
                      any Content on the Website that might be illegal or that otherwise violates this agreement 
                      or the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>. AllFans will review and resolve all reported complaints 
                      within five business days. We will suspend access to any Content you post on our Website that 
                      we become aware of that might not comply with this agreement, the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, or 
                      any law while we investigate the suspected noncompliance or unlawfulness of that Content. If 
                      we suspend access to your Content, you may request a review of our decision to suspend access 
                      to that Content by contacting us at support@allfans.com. After investigating the suspected 
                      noncompliance or unlawfulness of that Content, we may take any action we consider appropriate, 
                      including, but not limited to, reinstating access, permanently removing, or disabling access 
                      to that Content without needing to obtain your consent and without giving you prior notice. 
                      At your own cost, you must promptly provide us with all reasonable assistance (including 
                      providing us with copies of any information that we request) in our investigation. We will 
                      not be responsible for any loss you suffer arising from our suspending access to your 
                      Content or any other steps that we take in good faith to investigate any suspected noncompliance 
                      or unlawfulness of your Content under this section 12(b).</p>
                  </li>
                  <li>
                    <p>If we suspend access to or remove any of your Content, we will notify you by email or 
                      electronic message to your User account, but we are not required to give you prior notice 
                      of that removal.</p>
                  </li>
                  <li>
                    <p>If we suspend access to your account or terminate your agreement with us and your 
                      access to the Website, we will let you know. While access to your account is suspended, 
                      any payment that would otherwise have fallen due during the suspension will be suspended, 
                      and we may withhold earnings due to you but not yet paid if you are a Creator under the 
                      <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a>.</p>
                  </li>
                  <li>
                    <p>On termination of your account, we may deal with your Content in any appropriate manner 
                      in accordance with our <a href="/privacypolicy" onClick={(e) => { e.preventDefault(); navigate('/privacypolicy') }}>Privacy Policy</a> (including by deleting it) and you will no longer be 
                      entitled to access your Content. There is no technical facility on AllFans for you 
                      to be able to access your Content after termination of your account.</p>
                  </li>
                  <li>
                    <p>We will cooperate with any law enforcement authorities or court order requesting 
                      or directing us to disclose the identity or other information about anyone posting any 
                      Content on or through the Website. You hereby waive and shall indemnify AllFans 
                      and its affiliates, licensees, and service providers against any claims resulting from 
                      any action taken during, or taken because of, investigations by either AllFans 
                      or law enforcement authorities.</p>
                  </li>
                  <li>
                    <p>We review all Content before it is published to our Website to ensure that it 
                      is not illegal and does not otherwise violate this agreement, the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, 
                      or any law. In addition, in offering real-time or live video streaming Content, we 
                      operate on a platform that we can fully control and that allows for real-time monitoring 
                      and the removal of the Content being streamed. If we determine that any Content being 
                      streamed is illegal or otherwise violates this agreement, the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, 
                      the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a> if you are a Creator, or any law, we will promptly block and 
                      remove that Content. But we assume no liability for any action or inaction regarding 
                      transmissions, communications, or Content provided by any User or nonparty. We have 
                      no liability or responsibility to any User for performance or nonperformance of the 
                      activities described in this section 12.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Copyright Infringement</h5>
                <p>If you believe that any Content infringes your copyright, please see our <a href="/dmca" onClick={(e) => { e.preventDefault(); navigate('/dmca') }}>DMCA Policy</a> for 
                instructions on sending us a notice of copyright infringement. 
                  It is AllFans’s policy to terminate the User accounts of repeat infringers.</p>
              </li>
              <li>
                <h5>Reliance on Information Posted</h5>
                <ol>
                  <li>
                    <p>The information presented on or through the Website is made available solely 
                      for general information purposes. We are not making any statement about the accuracy, 
                      completeness, or usefulness of this information. Any reliance you place on that 
                      information is strictly at your own risk. We disclaim all liability and responsibility 
                      arising from any reliance placed on those materials by you or any other visitor to the 
                      Website, or by anyone who might be informed of any of its contents.</p>
                  </li>
                  <li>
                    <p>All statements or opinions expressed in Content and all articles and responses 
                      to questions and other content, other than the content provided by AllFans, 
                      are solely the opinions and the responsibility of the person or entity providing 
                      those materials. These materials do not necessarily reflect AllFans’s opinion. 
                      We are not responsible, or liable to you or any nonparty, for the content or accuracy 
                      of any materials provided by any User or nonparty.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Changes to the Website</h5>
                <p>We may update the Materials on this Website from time to time, but the Website’s 
                  Materials are not necessarily complete or up to date. The Website’s Materials might 
                  be out of date at any given time, and we are not required to update those Materials.</p>
              </li>
              <li>
                <h5>Information About You and Your Visits to the Website</h5>
                <p>For information about how we collect, use, and share your personal information, 
                  please review our <a href="/privacypolicy" onClick={(e) => { e.preventDefault(); navigate('/privacypolicy') }}>Privacy Policy</a>.</p>
              </li>
              <li>
                <h5>Creator Competitions</h5>
                <p>Creators may promote competitions, promotions, prize draws, and other similar 
                  opportunities on the Website (“Creator Competitions”). We are not the sponsor 
                  or promoter of those Creator Competitions and do not bear any responsibility or 
                  liability for the actions or inactions of any Creator who organizes, administers, 
                  or is otherwise involved in any promotion of those Creator Competitions. If you 
                  wish to participate in any Creator Competition, you are responsible for reading 
                  and ensuring that you understand the rules and any eligibility requirements and 
                  are lawfully able to participate in that Creator Competition in your place of 
                  residence.</p>
              </li>
              <li>
                <h5>Subscriptions and Purchases</h5>
                <ol>
                  <li>
                    <p>All Fan/Creator Transactions are contracts between Fans and Creators 
                      on the terms of the <a href="/fancreatorcontract" onClick={(e) => { e.preventDefault(); navigate('/fancreatorcontract') }}>Standard Agreement between Fan and Creator</a>. Although we 
                      facilitate Fan/Creator Transactions by providing the Website, storing Content, 
                      and acting as a payment intermediary, we are not a party to the <a href="/fancreatorcontract" onClick={(e) => { e.preventDefault(); navigate('/fancreatorcontract') }}>Standard Agreement between Fan and Creator</a> or any other agreement that might exist between a Fan and 
                      a Creator. We are not responsible for any Fan/Creator Transactions. </p>
                  </li>
                  <li>
                    <p>Creators are solely responsible for determining (within the Website’s 
                      pricing parameters) the pricing applicable to Fan/Creator Transactions and 
                      the Content to which you may be given access. All prices appear in USD only.</p>
                  </li>
                  <li>
                    <p>Fan Payments are exclusive of Tax, which will be added at the current rate 
                      as applicable to Fan Payments.</p>
                  </li>
                  <li>
                    <p>To enter into a Fan/Creator Transaction with a particular Creator, you must 
                      first add a payment card to your account and then click the “Subscribe” button on 
                      the relevant Creator’s profile.</p>
                  </li>
                  <li>
                    <p>You hereby authorize us to give your payment card details to our third-party 
                      payment processor to process your Fan Payment. All Fan Payments will be charged 
                      in USD. Your payment card provider may charge you currency conversion fees. 
                      We do not control currency exchange rates or charges imposed by your payment 
                      card provider or bank. We are not responsible for paying any charges or fees 
                      imposed by your payment card provider or bank.</p>
                  </li>
                  <li>
                    <p>If you choose to provide details for two or more payment cards and then 
                      try to make a Fan Payment from the first card and that card is rejected for any 
                      reason, then the other payment card will be used to collect the full Fan Payment.</p>
                  </li>
                  <li>
                    <p>The payment provider will take (1) periodic payments from your payment card for 
                      Fan Payments that are Subscriptions; and (2) immediate payments from your payment 
                      card for Fan Payments other than Subscriptions (including any tips paid by you to 
                      a Creator). You hereby authorize and consent to each of these payments being debited 
                      using your supplied payment card details.</p>
                  </li>
                  <li>
                    <p>Besides free-trial Subscriptions, all Subscriptions to a Creator’s profile will 
                      automatically renew at the end of the relevant subscription period, except if your 
                      payment card is declined, the subscription price for the Subscription has increased, 
                      or you have turned off the “Auto-Renew” switch located on the relevant Creator’s profile. 
                      This means that if you want to stop subscribing to a Creator’s profile and paying 
                      continuing monthly subscription charges, you will need to turn off the “Auto-Renew” 
                      switch located on the relevant Creator’s profile.</p>
                  </li>
                  <li>
                    <p>If you cancel a Subscription, you will continue to have access to the relevant 
                      Creator’s Content until the end of the Subscription period, after which no further 
                      payments will be taken from your payment card regarding Subscriptions to that 
                      Creator’s profile (unless you choose to pay for a new Subscription to that Creator’s 
                      profile), and you will no longer be able to view the relevant Creator’s Content.</p>
                  </li>
                  <li>
                    <p>You can prepay an amount on the Website (“Wallet Credits”) that you can later 
                      use to make Fan Payments. Purchases on the Website cannot be divided—if you try 
                      a purchase that costs more than the amount of your remaining Wallet Credits, 
                      your payment card will be charged the full amount for that purchase. Wallet 
                      Credits are subject to a maximum amount as determined by us from time to time. 
                      Wallet Credits will not accrue interest. Wallet Credits are nonrefundable, 
                      which means that AllFans is not required to refund any unused Wallet Credits.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Billing Disputes</h5>
                <p>If you believe that we have charged you in error, you must notify us in writing no 
                  later than 30 days after receiving the billing statement in which the error first appeared. 
                  If you do not notify us in writing of a dispute within this 30-day period, you waive any 
                  disputed charges. You must submit any billing disputes to us by email at support@allfans.com. 
                  Please include a detailed statement describing the nature and amount of the disputed charges. 
                  We will correct any mistakes in a bill and add or credit them against your future Fan Payments. 
                  If we consider that any billing dispute made by you was made in bad faith, we may suspend or 
                  terminate your User account or any future User account you create.</p>
              </li>
              <li>
                <h5>Refund Policy</h5>
                <p>Except as provided by law, all sales and transactions are final. Fan Payments are nonrefundable 
                  and earned on receipt. You must not make unjustified requests for a refund regarding any 
                  Fan/Creator Transaction or a tip to a Creator. If you are unhappy with a Fan/Creator Transaction, 
                  please inform the applicable Creator. If there is a technical error on the Website, we will work 
                  with you to resolve it. We may approve a refund in the form of a credit on request if exceptional 
                  circumstances exist. If you believe exceptional circumstances exist for a refund, please email 
                  us at support@allfans.com and explain the circumstances you believe merits a refund. We are not 
                  making any promise that we will give you a refund. If we issue a refund at our sole discretion, 
                  we will issue that refund in the form of a credit to the payment method you used for that Fan Payment. 
                  We will not make refunds in the form of cash, check, or free services. The provision of a refund in 
                  one instance does not entitle you to a refund in the future for similar instances, nor does it require 
                  us to issue refunds in the future under any circumstance. If we consider that any request for a refund 
                  was made by you in bad faith, we may suspend or terminate your User account or any future User account 
                  you create.</p>
              </li>
              <li>
                <h5>Chargeback Policy</h5>
                <p>We carefully investigate all chargebacks. Chargebacks are initiated when individuals reach out 
                  to their financial institutions to dispute a transaction. You must not make unjustified chargeback 
                  requests of your payment card provider for any Fan/Creator Transaction or tip to a Creator. To 
                  protect Creators, we will review excessive and potentially fraudulent chargebacks and may prohibit 
                  you from making additional purchases during that review. If we consider that any chargeback request 
                  is fraudulent or was made by you in bad faith, we may suspend or terminate your User account or any 
                  future User account you create.</p>
              </li>
              <li>
                <h5>Linking to the Website and Social Media Features.</h5>
                <ol>
                  <li>
                    <p>You may link to our homepage or your profile page, on condition that you do so in a way 
                      that is fair and legal and does not damage our reputation or take advantage of it, but you 
                      must not establish a link in such a way as to suggest any form of association, approval, 
                      or endorsement on our part without our express written consent.</p>
                  </li>
                  <li>
                    <p>This Website may provide certain social media features that enable you to:</p>
                    <ol>
                      <li><p>link from your own or certain nonparty websites to certain content on this Website;</p></li>
                      <li><p>send emails or other communications with certain content, or links to certain content, on this Website; and</p></li>
                      <li>
                        <p>cause limited parts of content on this Website to be displayed or appear to be displayed 
                          on your own or certain nonparty websites.</p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>You may use the features set out in section 22(b) solely as they are provided by us 
                      solely for the content they are displayed with, and otherwise under any additional terms 
                      we provide for those features. Subject to the preceding, you must not:</p>
                      <ol>
                        <li><p>establish a link from any website that is not owned by you;</p></li>
                        <li><p>cause the Website or parts of it to be displayed on, or appear to 
                          be displayed by, any other site, for example, framing, deep linking, or in-line linking;</p></li>
                        <li><p>link to any part of the Website other than the homepage or your profile page; or</p></li>
                        <li><p>otherwise take any action regarding the materials on this Website that is inconsistent 
                          with any other provision of this agreement.</p></li>
                      </ol>
                  </li>
                  <li>
                    <p>The website from which you are linking, or on which you make certain content 
                      accessible, must comply in all respects with the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>.</p>
                  </li>
                  <li>
                    <p>You must cooperate with us in causing any unauthorized framing or linking immediately to 
                      stop. We may withdraw linking permission without notice.</p>
                  </li>
                  <li>
                    <p>We may disable any social media features and any links at any time without notice.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Links from the Website</h5>
                <p>If the Website contains links to other sites and resources provided by nonparties, these links 
                  are provided for your convenience only. This includes links contained in advertisements, 
                  including banner advertisements and sponsored links. We have no control over the contents of 
                  those sites or resources and accept no responsibility for them or for any loss or damage that 
                  might arise from your use of them. If you decide to access any of the nonparty websites linked 
                  to this Website, you do so entirely at your own risk and subject to the terms of use for those 
                  websites.</p>
              </li>
              <li>
                <h5>Warranty Disclaimers</h5>
                <ol>
                  <li>
                    <p><strong>AllFans provides the Website “as is” and “as available.” You use the Website at 
                      your own risk.</strong></p>
                  </li>
                  <li>
                    <p><strong>Except as expressly set out in this agreement, and to the extent permitted by law, 
                      AllFans is not making any warranties, express or implied, including implied 
                      warranties of merchantability, fitness for a particular purpose, title, and noninfringement</strong>. 
                      Among other things, AllFans is not making any warranty (1) that the Website, or any 
                      part of it, will be available or permitted in your jurisdiction, uninterrupted or error-free, 
                      completely secure, or accessible from all devices or browsers; (2) that we will host, make 
                      available, or remove any specific piece of Content; (3) concerning any Content submitted by 
                      or actions of our Users; (4) that any geo-filtering or digital rights management solution 
                      that we might offer will be effective; (5) that the Website will meet your business or 
                      professional needs; (6) that we will continue to support any particular feature or maintain 
                      backwards compatibility with any third-party software or device; or (7) concerning any 
                      third-party websites and resources.</p>
                  </li>
                  <li>
                    <p><strong>The disclaimers of warranty under this section also apply to our subsidiaries, 
                      affiliates, and third-party service providers.</strong></p>
                  </li>
                  <li>
                    <p><strong>The above does not affect any warranties that cannot be excluded or limited under law.</strong></p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Limitation of Liability</h5>
                <ol>
                  <li>
                    <p><strong>To the extent permitted by law, (1) AllFans is not liable to you for any 
                      indirect, incidental, special, consequential, punitive, or exemplary damages, including damages 
                      for loss of business, profits, goodwill, data, or other intangible losses, even if AllFans 
                      has been advised of the possibility of those damages; and (2) AllFans’s total liability to 
                      you, except for AllFans’s contractual payment obligations under this agreement (if any), 
                      will not exceed the amounts paid by you to AllFans over the six months preceding your claim(s) 
                      or US$500, whichever is greater. In this section 25, “AllFans” includes its subsidiaries, 
                      affiliates, officers, managers, employees, agents, and third-party service providers.</strong></p>
                  </li>
                  <li>
                    <p>The limitation of liability set out above does not apply to liability resulting from our gross 
                      negligence or willful misconduct or death or bodily injury caused by products or services you purchase 
                      through the Website.</p>
                  </li>
                  <li>
                    <p><strong>The above does not affect any liability that cannot be excluded or limited under law.</strong></p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Indemnification</h5>
                <p>You shall indemnify us against all losses and liabilities, including legal fees, that arise from this 
                  agreement or relate to your use of the Website, including your submission of Content. We reserve the right 
                  to exclusive control over the defense of a claim covered by this section. If we exercise this right, then 
                  you will help us in our defense. Your obligation to indemnify under this section also applies to our 
                  subsidiaries, affiliates, officers, managers, employees, agents, and third-party service providers.</p>
              </li>  
              <li>
                <h5>Governing Law and Jurisdiction; Jury Trial Waiver</h5>
                <ol>
                  <li>
                    <p>Delaware law governs all adversarial proceedings arising out of this agreement or access or use of 
                      the Website. This agreement’s predominant purpose is providing services and licensing access to intellectual 
                      property and not a “sale of goods.” The United Nations Convention on Contracts for the International Sale 
                      of Goods will not govern this agreement, the application of which is expressly excluded.</p>
                  </li>
                  <li>
                    <p>Except for disputes subject to arbitration, as the exclusive means of bringing adversarial 
                      proceedings to resolve any dispute arising out of this agreement or the subject matter of this 
                      agreement, a party may bring such a proceeding in the United States District Court for the District 
                      of Delaware or in a state court of Delaware. Each party acknowledges that those courts would be a 
                      convenient forum.</p>
                  </li>
                  <li>
                    <p><strong>Each party hereby waives its right to a trial by jury in any adversarial proceedings 
                      arising out of this agreement.</strong></p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Arbitration; Class Action Waiver</h5>
                <ol>
                  <li>
                    <p>You and AllFans are agreeing to give up any rights to litigate claims in a court 
                      or before a jury, or to participate in a class action or representative action with respect to a 
                      claim. Other rights that you would have if you went to court may also be unavailable or may be 
                      limited in arbitration. Any claim, dispute, or controversy (whether in contract, tort, or 
                      otherwise, whether pre-existing, present, or future, and including statutory, consumer protection, 
                      common law, intentional tort, injunctive, and equitable claims) between you and us arising from or 
                      relating in any way to your use of the Website, will be resolved exclusively and finally by 
                      binding arbitration.</p>
                  </li>
                  <li>
                    <p>Arbitration Resolution Services, Inc. (ARS) (or a similar online dispute resolution 
                      provider if ARS is not available) will administer the arbitration under its rules available 
                      at www.arbresolutions.com, then in effect, except as modified by this section 28. The 
                      Federal Arbitration Act will govern the interpretation and enforcement of this section 28. 
                      The arbitrator will have exclusive authority to resolve any dispute relating to arbitrability 
                      or enforceability of this arbitration provision, including any unconscionability challenge 
                      or any other challenge that the arbitration provision or the agreement is void, voidable, 
                      or otherwise invalid. The arbitrator will be empowered to grant whatever relief would be 
                      available in court under law or in equity. Any award from the arbitrator will be final and 
                      binding on each of the parties and may be entered as a judgment in any court of competent 
                      jurisdiction. If you prevail on any claim that affords the prevailing party legal fees, the 
                      arbitrator may award reasonable fees to you under the standards for fee shifting provided by law.</p>
                  </li>
                  <li>
                    <p>You may elect to pursue your claim in small-claims court rather than arbitration if you 
                      provide us with written notice of your intent to do so within 60 days of the date your claim arose. 
                      The arbitration or small-claims court proceeding will be limited solely to your individual 
                      dispute or controversy.</p>
                  </li>
                  <li>
                    <p><strong>You agree to arbitrate on an individual basis. In any dispute, neither you nor 
                      AllFans will be entitled to join or consolidate claims by or against other Users in 
                      court or in arbitration or otherwise participate in any claim as a class representative, class 
                      member, or in a private attorney general capacity. The arbitral tribunal will not consolidate 
                      more than one person’s claims and will not otherwise preside over any form of a representative 
                      or class proceeding. The arbitral tribunal has no power to consider the enforceability of this 
                      class arbitration waiver and any challenge to the class arbitration waiver may only be raised 
                      in a court of competent jurisdiction.</strong></p>
                  </li>
                  <li>
                    <p>If any provision of this section 28 is found unenforceable, the unenforceable provision 
                      will be severed, and the remaining arbitration terms will be enforced.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Recovery of Expenses</h5>
                <p>In any proceedings between the parties arising out of this agreement or relating to the subject 
                  matter of this agreement, the prevailing party will be entitled to recover from the other party, 
                  besides any other relief awarded, all expenses that the prevailing party incurs in those proceedings, 
                  including legal fees and expenses.</p>
              </li>  
              <li>
                <h5>Limitation on Time to Bring Claims</h5>
                <p>A party shall not bring a claim arising out of this agreement or access or use of the Website 
                  more than one year after the cause of action arose. Any claim brought after one year is barred.</p>
              </li>  
              <li>
                <h5>Entire Agreement</h5>
                <p>This agreement constitutes the entire understanding between the parties regarding the subject 
                  matter of this agreement and supersedes all other agreements, whether written or oral, between 
                  the parties, except that any additional terms on the Website will govern the items to which 
                  they pertain, including, but not limited to, the <a href="/acceptableuse" onClick={(e) => { e.preventDefault(); navigate('/acceptableuse') }}>Acceptable Use Policy</a>, the <a href="/privacypolicy" onClick={(e) => { e.preventDefault(); navigate('/privacypolicy') }}>Privacy Policy</a>, 
                  the <a href="/dmca" onClick={(e) => { e.preventDefault(); navigate('/dmca') }}>DMCA Policy</a>, the <a href="/complaintspolicy" onClick={(e) => { e.preventDefault(); navigate('/complaintspolicy') }}>Complaints Policy</a>, the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }}>Creator Terms</a>, and the <a href="/referralterms" onClick={(e) => { e.preventDefault(); navigate('/referralterms') }}>Referral Program Terms</a>.</p>
              </li>  
              <li>
                <h5>Assignment</h5>
                <p>This agreement is personal to you. You shall not transfer to any person (1) any discretion granted 
                  under this agreement, (2) any right to satisfy a condition under this agreement, (3) any remedy under 
                  this agreement, or (4) any obligation imposed under this agreement. Any purported transfer by you in 
                  violation of this section 32 will be void.</p>
              </li> 
              <li>
                <h5>Waiver</h5>
                <p>No waiver under this agreement will be effective unless it is in writing and signed by the party granting 
                  the waiver. A waiver granted on one occasion will not operate as a waiver on other occasions.</p>
              </li> 
              <li>
                <h5>Severability</h5>
                <p>If any provision of this agreement is held to be unenforceable, then that provision is 
                  modified to the extent necessary to enforce it. If a provision cannot be modified to make it 
                  enforceable, then it is severed from this agreement, and all other provisions remain in force.</p>
              </li> 
              <li>
                <h5>Notices</h5>
                <ol>
                  <li>
                    <p>You may give notice to us by email at legal@allfans.com or by mail at Innodev Solutions Inc., 
                      Attn: Legal Department, 2108 N ST #6819, SACRAMENTO, CA 95816. We may change our contact 
                      information on one or more occasions by posting the change on the Website. Please check the 
                      Website for the most current information for notifying us.</p>
                  </li>
                  <li>
                    <p>You consent to receive any notice from us in electronic form either (1) by email to 
                      the last known email address we have for you or (2) by posting the notice on a place on the 
                      Website chosen for this purpose. You state that any email address you gave us for contacting you 
                      is a valid email address for receiving notice.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>No Third-Party Beneficiaries</h5>
                <p>Except as set out in section 26, this agreement does not, and the parties do not intend it to, 
                  confer any rights or remedies on any person other than the parties to this agreement.</p>
              </li>
              <li>
                <h5>Unsolicited Idea Submission Policy</h5>
                <ol>
                  <li>
                    <p>We and our employees do not accept or consider unsolicited ideas, suggestions, proposals, 
                      comments, or materials, including new or improved products, services or technologies, product 
                      or service enhancements, processes, advertising campaigns, promotions, marketing plans, or new 
                      product or service names (collectively, “<strong>Submissions</strong>”). Please do not send any Submissions in 
                      any form to us or any of our employees. The sole purpose of this policy is to avoid potential 
                      misunderstandings or disputes when our products, services, marketing, or other projects might 
                      seem similar to any Submissions made to us. If, despite our policy, you still submit your 
                      ideas to us, the following terms will apply to your Submissions, regardless of what your 
                      communication states. You acknowledge that: (1) we will consider the Submissions to be 
                      nonconfidential and nonproprietary; (2) we may use, copy, redistribute, and disclose the 
                      Submissions for any purpose in any way, without compensation to you or any other person 
                      or party; and (3) we will have no obligations for the Submissions, including no obligation 
                      to review the Submissions, return any materials, or acknowledge receipt of the Submissions. 
                      If you do not agree to these terms, please do not send us any Submissions.</p>
                  </li>
                  <li>
                    <p>While we cannot accept unsolicited ideas, we always welcome feedback on our existing business. 
                      If you want to send us your feedback, please only provide specific feedback on our existing business 
                      and do not include ideas that the policy stated in section 37 prohibits. Any feedback you provide 
                      is considered nonconfidential and nonproprietary. We will be free to use that information on an 
                      unrestricted basis with no compensation to you or any other person or party. </p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Your Comments and Concerns</h5>
                <p>The Website is operated by Innodev Solutions Inc., 2108 N ST #6819, SACRAMENTO, CA 95816. All notices of copyright 
                  infringement claims should be sent to the copyright agent designated in our <a href="/dmca" onClick={(e) => { e.preventDefault(); navigate('/dmca') }}>DMCA Policy</a> in the manner 
                  and by the means set out in it. All abuse notices, including alleged child sexual abuse material (CSAM), 
                  should be directed to abuse@allfans.com. You should direct all other feedback, comments, requests for 
                  technical support, and other communications relating to the Website to us at support@allfans.com.</p>
              </li>
          </ol>
          <div style={{ paddingTop: '200px' }}></div>
        </div>
      </div>
    </div>
        </>
  );
};

export default Terms;
